import { render } from "./Errors.vue?vue&type=template&id=81a921b8&scoped=true"
const script = {}

import "./Errors.vue?vue&type=style&index=0&id=81a921b8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81a921b8"]])

export default __exports__